var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M68 39L.5 77.971V.03L68 39z","fill":"#E6E5E1"}));
}

PlayInline.defaultProps = {"viewBox":"0 0 68 78","fill":"none"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
